// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hihIjSoKxI_gvBVcxgv2{grid-template-rows:auto 1fr;max-width:100%;padding:16px 20px;display:grid}@media (min-width:1200px){.hihIjSoKxI_gvBVcxgv2{max-width:720px}}@media (min-width:1440px){.hihIjSoKxI_gvBVcxgv2{max-width:720px}.zvvmed3F3EkAFN1p50Pa{max-width:940px}}@media (min-width:1920px){.hihIjSoKxI_gvBVcxgv2{max-width:1040px}.zvvmed3F3EkAFN1p50Pa{max-width:1260px}}.qxJd0owb5108j3Bo4VsM{margin:0 -8px 0 -2px}.o3wL4qJO8EcFol3dsVUT{position:relative}.o3wL4qJO8EcFol3dsVUT:before{background-color:var(--white-60);z-index:5;content:"";position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `hihIjSoKxI_gvBVcxgv2`,
	"wrap--collapse": `zvvmed3F3EkAFN1p50Pa`,
	"wrapCollapse": `zvvmed3F3EkAFN1p50Pa`,
	"tabs": `qxJd0owb5108j3Bo4VsM`,
	"loadingCreating": `o3wL4qJO8EcFol3dsVUT`
};
export default ___CSS_LOADER_EXPORT___;
